<template>
  <div class="breadcrumb">
    <ul>
      <li v-for="({name, path, label = null, params = {}}, index) in breadCrumb" :key="index">
        <template v-if="index === breadCrumb.length - 1">
          <span>{{label || $t(`breadcrumbs.${name}`, params)}}</span>
        </template>
        <nuxt-link :to="path" v-else>{{label || $t(`breadcrumbs.${name}`, params)}}</nuxt-link>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'f-breadcrumb',
    computed: {
      breadCrumb() {
        return this.$store.getters.getBreadCrumb()
      }
    }
  }
</script>

<style scoped>
  .breadcrumb > ul {
    display: flex;
    align-items: stretch;
  }

  .breadcrumb a {
    text-decoration: none;
    color: #fff;
  }
</style>
